import React from "react";
import { Modal, ModalBody } from "react-bootstrap";
import Image from "../Reusable/Image";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import SubmitButtonTwo from "../Reusable/Buttontwo";
import CustomTextFieldTwo from "../Reusable/CustomTextFieldTwo";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import RoutesPath from "../../Utils/RoutesPath";
import { handleApiErrors, InputType, validationRegex } from "../../Utils/Utils";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const FormModal = ({ showModal, setShowModal, title, children, titleone, titletwo }) => {

    const schema = yup.object().shape({
        amount: validationRegex.required,
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema),
        defaultValues: { amount: "" },
    });

    const getwithdrawlamount = async (data) => {
        try {
            // Assume `coordinator_id` is available in props or another state
            const response = await CoordinatorApiServices.getwithdrawlamount(
                data.coordinator_id,  // Make sure this is provided
                data.amount
            );
            toast.success(response.message);
            reset();
            setShowModal(false)
            // Navigate or handle success as required
        } catch (error) {
            handleApiErrors(error);
            reset();
            toast.error("Failed to request withdrawal. Please try again later.");
        }
    };

    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered // Center the modal vertically and horizontally
            aria-labelledby="exampleModalToggleLabel2"
            contentClassName="p-0 bg-transparent border-0 shadow-none"
        >
            <ModalBody className="p-0">
                <div>
                    <div className="modal-content p-4" style={{ borderStyle: 'none', borderRadius: '26px' }} >
                        <div className="modal-header p-0 mb-3" style={{ borderBottom: 'none' }}>
                            <h2 className="medium-text fw-600  mb-0" style={{ fontStyle: 'italic', color: '#FF0000' }}>{title}</h2>
                            <Image className="cursor-pointer" src={PngImages.redcross} style={{ aspectRatio: 1 }} onClick={() => setShowModal(false)} />
                        </div>
                        <div>
                            <li className="small-medium-text fw-500">{titleone}</li>
                            <li className="small-medium-text fw-500 mt-3">{titletwo}</li>
                        </div>
                        <div className="mt-3">
                            <CustomTextFieldTwo
                                additionalClasses="profile_edit"
                                labelClass="TextInput"
                                inputType={InputType.number}
                                id="amount"
                                name="amount"
                                placeholder="Enter Amount"
                                showError={errors?.amount}
                                errorMessage={errors?.amount?.message}
                                register={register}
                            />
                        </div>
                        <div className="modal-body p-0">
                            {children}
                        </div>
                        <div className="modal-footer p-0 " style={{ borderTop: 'none' }}>
                            <SubmitButtonTwo title={"Request"} onclick={handleSubmit(getwithdrawlamount)} className="requestbutton fw-600" />
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default FormModal;
